import cn from 'classnames'
import * as React from 'react'

import styles from './layout-row.module.scss'

interface IRowProps {
  top?: 'first' | 'second'
  alignItems?: 'center' | 'start' | 'end'
}
const Row = ({
  className,
  children,
  top = 'first',
  alignItems = 'center',
  ...rest
}: IRowProps & React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn(styles.row, top === 'second' && styles.reverse, styles[alignItems], className)} {...rest}>
    {children}
  </div>
)

interface IColumnProps {
  first?: boolean
  limitWidth?: boolean
}
const Column = ({
  first,
  limitWidth,
  className,
  children,
  ...rest
}: IColumnProps & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(styles.column, first && styles.firstColumn, limitWidth && styles.limitWidthColumn, className)}
    {...rest}
  >
    {limitWidth ? <div className={styles.innerColumn}>{children}</div> : children}
  </div>
)

export { Row, Column }
